import * as Tile from './Tile.styles'

export default Tile
